// This file is autogenerated by tools/genMaterialLibrary. DO NOT EDIT IT DIRECTLY.
export const DesignMaterialTemplateColorLibs = {
  Color: ["SystemColors"],
  Floor_Concrete: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Concrete_SherwinWilliams",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "Metal_ACM",
    "Metal_Amerimax",
    "Norandex",
    "Olympic",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "SherwinWilliams",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "Westlake",
    "WolfHomeProducts",
  ],
  Floor_ConcreteBroomFinish: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Concrete_SherwinWilliams",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "Metal_ACM",
    "Metal_Amerimax",
    "Norandex",
    "Olympic",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "SherwinWilliams",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "Westlake",
    "WolfHomeProducts",
  ],
  Garage: [
    "CHI_Colors",
    "DunnEdwards",
    "Garaga",
    "Garage_Amarr",
    "Garage_Clopay",
    "Garage_Colors",
    "Garage_DoorLink",
    "Garage_GeneralDoors",
    "Garage_Hormann",
    "Garage_Martin",
    "Garage_OverheadDoor",
    "Garage_Windsor",
    "HaasDoor",
    "Masonite",
    "WayneDalton",
  ],
  Gutter: ["GutterHelp", "Lonestar", "Masonite", "Norandex", "Rollex"],
  Lattice_45deg_1x1: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "BenjaminMoore",
    "BuildersEdge",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "Metal_ACM",
    "Metal_Amerimax",
    "Norandex",
    "Olympic",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "Westlake",
    "WolfHomeProducts",
  ],
  Masonry_Brick_03: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "DiamondKote",
    "Dulux",
    "FloridaPaints",
    "HaasDoor",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Metal_ACM",
    "Metal_Amerimax",
    "Mortar_GeneralShale",
    "PPG",
    "PaintSpare_Colors",
    "RoyalBuilding",
    "SherwinWilliams",
    "ThermaTru",
    "TimberTech",
    "Waudena",
    "Westlake",
    "WolfHomeProducts",
  ],
  Masonry_Brick_03_Header: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "DiamondKote",
    "Dulux",
    "FloridaPaints",
    "HaasDoor",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Metal_ACM",
    "Metal_Amerimax",
    "Mortar_GeneralShale",
    "PPG",
    "PaintSpare_Colors",
    "RoyalBuilding",
    "SherwinWilliams",
    "ThermaTru",
    "TimberTech",
    "Waudena",
    "Westlake",
    "WolfHomeProducts",
  ],
  Masonry_Brick_03_Rowlock: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "DiamondKote",
    "Dulux",
    "FloridaPaints",
    "HaasDoor",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Metal_ACM",
    "Metal_Amerimax",
    "Mortar_GeneralShale",
    "PPG",
    "PaintSpare_Colors",
    "RoyalBuilding",
    "SherwinWilliams",
    "ThermaTru",
    "TimberTech",
    "Waudena",
    "Westlake",
    "WolfHomeProducts",
  ],
  Masonry_Brick_05: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "DiamondKote",
    "Dulux",
    "FloridaPaints",
    "HaasDoor",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Metal_ACM",
    "Metal_Amerimax",
    "Mortar_GeneralShale",
    "PPG",
    "PaintSpare_Colors",
    "RoyalBuilding",
    "SherwinWilliams",
    "ThermaTru",
    "TimberTech",
    "Waudena",
    "Westlake",
    "WolfHomeProducts",
  ],
  Masonry_Brick_05_Header: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "DiamondKote",
    "Dulux",
    "FloridaPaints",
    "HaasDoor",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Metal_ACM",
    "Metal_Amerimax",
    "Mortar_GeneralShale",
    "PPG",
    "PaintSpare_Colors",
    "RoyalBuilding",
    "SherwinWilliams",
    "ThermaTru",
    "TimberTech",
    "Waudena",
    "Westlake",
    "WolfHomeProducts",
  ],
  Masonry_Brick_05_Rowlock: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "DiamondKote",
    "Dulux",
    "FloridaPaints",
    "HaasDoor",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Metal_ACM",
    "Metal_Amerimax",
    "Mortar_GeneralShale",
    "PPG",
    "PaintSpare_Colors",
    "RoyalBuilding",
    "SherwinWilliams",
    "ThermaTru",
    "TimberTech",
    "Waudena",
    "Westlake",
    "WolfHomeProducts",
  ],
  Masonry_Brick_075: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "DiamondKote",
    "Dulux",
    "FloridaPaints",
    "HaasDoor",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Metal_ACM",
    "Metal_Amerimax",
    "Mortar_GeneralShale",
    "PPG",
    "PaintSpare_Colors",
    "RoyalBuilding",
    "SherwinWilliams",
    "ThermaTru",
    "TimberTech",
    "Waudena",
    "Westlake",
    "WolfHomeProducts",
  ],
  Masonry_Brick_075_Header: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "DiamondKote",
    "Dulux",
    "FloridaPaints",
    "HaasDoor",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Metal_ACM",
    "Metal_Amerimax",
    "Mortar_GeneralShale",
    "PPG",
    "PaintSpare_Colors",
    "RoyalBuilding",
    "SherwinWilliams",
    "ThermaTru",
    "TimberTech",
    "Waudena",
    "Westlake",
    "WolfHomeProducts",
  ],
  Masonry_Brick_075_Rowlock: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "DiamondKote",
    "Dulux",
    "FloridaPaints",
    "HaasDoor",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Metal_ACM",
    "Metal_Amerimax",
    "Mortar_GeneralShale",
    "PPG",
    "PaintSpare_Colors",
    "RoyalBuilding",
    "SherwinWilliams",
    "ThermaTru",
    "TimberTech",
    "Waudena",
    "Westlake",
    "WolfHomeProducts",
  ],
  Masonry_Brick_Bracciano: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "DiamondKote",
    "Dulux",
    "FloridaPaints",
    "HaasDoor",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Metal_ACM",
    "Metal_Amerimax",
    "Mortar_GeneralShale",
    "PPG",
    "PaintSpare_Colors",
    "RoyalBuilding",
    "SherwinWilliams",
    "ThermaTru",
    "TimberTech",
    "Waudena",
    "Westlake",
    "WolfHomeProducts",
  ],
  Masonry_Brick_Bracciano_Header: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "DiamondKote",
    "Dulux",
    "FloridaPaints",
    "HaasDoor",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Metal_ACM",
    "Metal_Amerimax",
    "Mortar_GeneralShale",
    "PPG",
    "PaintSpare_Colors",
    "RoyalBuilding",
    "SherwinWilliams",
    "ThermaTru",
    "TimberTech",
    "Waudena",
    "Westlake",
    "WolfHomeProducts",
  ],
  Masonry_Brick_Bracciano_Rowlock: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "DiamondKote",
    "Dulux",
    "FloridaPaints",
    "HaasDoor",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Metal_ACM",
    "Metal_Amerimax",
    "Mortar_GeneralShale",
    "PPG",
    "PaintSpare_Colors",
    "RoyalBuilding",
    "SherwinWilliams",
    "ThermaTru",
    "TimberTech",
    "Waudena",
    "Westlake",
    "WolfHomeProducts",
  ],
  Masonry_BrickDoubleMonarch_StackBond: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Metal_ACM",
    "Metal_Amerimax",
    "Mortar_GeneralShale",
    "Norandex",
    "Olympic",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "SherwinWilliams",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "Westlake",
    "WolfHomeProducts",
  ],
  Masonry_BrickEngineer: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Metal_ACM",
    "Metal_Amerimax",
    "Mortar_GeneralShale",
    "Norandex",
    "Olympic",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "SherwinWilliams",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "Westlake",
    "WolfHomeProducts",
  ],
  Masonry_BrickEstate: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Metal_ACM",
    "Metal_Amerimax",
    "Mortar_GeneralShale",
    "Norandex",
    "Olympic",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "SherwinWilliams",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "Westlake",
    "WolfHomeProducts",
  ],
  Masonry_BrickExecutive: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Mortar_GeneralShale",
    "Norandex",
    "Olympic",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Westlake",
    "WolfHomeProducts",
  ],
  Masonry_BrickExecutive_HalfHeight: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Mortar_GeneralShale",
    "Norandex",
    "Olympic",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Westlake",
    "WolfHomeProducts",
  ],
  Masonry_BrickExecutive_Header: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Mortar_GeneralShale",
    "Norandex",
    "Olympic",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Westlake",
    "WolfHomeProducts",
  ],
  Masonry_BrickExecutive_Herringbone: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Mortar_GeneralShale",
    "Norandex",
    "Olympic",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Westlake",
    "WolfHomeProducts",
  ],
  Masonry_BrickExecutive_Rowlock: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Mortar_GeneralShale",
    "Norandex",
    "Olympic",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Westlake",
    "WolfHomeProducts",
  ],
  Masonry_BrickExecutive_ThinCut: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Mortar_GeneralShale",
    "Norandex",
    "Olympic",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Westlake",
    "WolfHomeProducts",
  ],
  Masonry_BrickKing: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Metal_ACM",
    "Metal_Amerimax",
    "Mortar_GeneralShale",
    "Norandex",
    "Olympic",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "SherwinWilliams",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "Westlake",
    "WolfHomeProducts",
  ],
  Masonry_BrickKing_HalfHeight: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Metal_ACM",
    "Metal_Amerimax",
    "Mortar_GeneralShale",
    "Norandex",
    "Olympic",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "SherwinWilliams",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "Westlake",
    "WolfHomeProducts",
  ],
  Masonry_BrickKing_Header: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Metal_ACM",
    "Metal_Amerimax",
    "Mortar_GeneralShale",
    "Norandex",
    "Olympic",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "SherwinWilliams",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "Westlake",
    "WolfHomeProducts",
  ],
  Masonry_BrickKing_Herringbone: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Metal_ACM",
    "Metal_Amerimax",
    "Mortar_GeneralShale",
    "Norandex",
    "Olympic",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "SherwinWilliams",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "Westlake",
    "WolfHomeProducts",
  ],
  Masonry_BrickKing_Rowlock: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Metal_ACM",
    "Metal_Amerimax",
    "Mortar_GeneralShale",
    "Norandex",
    "Olympic",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "SherwinWilliams",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "Westlake",
    "WolfHomeProducts",
  ],
  Masonry_BrickKing_ThinCut: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Metal_ACM",
    "Metal_Amerimax",
    "Mortar_GeneralShale",
    "Norandex",
    "Olympic",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "SherwinWilliams",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "Westlake",
    "WolfHomeProducts",
  ],
  Masonry_BrickModular: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Metal_ACM",
    "Metal_Amerimax",
    "Mortar_GeneralShale",
    "Norandex",
    "Olympic",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "SherwinWilliams",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "Westlake",
    "WolfHomeProducts",
  ],
  Masonry_BrickModular_HalfHeight: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Mortar_GeneralShale",
    "Norandex",
    "Olympic",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "Westlake",
    "WolfHomeProducts",
  ],
  Masonry_BrickModular_Header: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Metal_ACM",
    "Metal_Amerimax",
    "Mortar_GeneralShale",
    "Norandex",
    "Olympic",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "SherwinWilliams",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "Westlake",
    "WolfHomeProducts",
  ],
  Masonry_BrickModular_Herringbone: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Metal_ACM",
    "Metal_Amerimax",
    "Mortar_GeneralShale",
    "Norandex",
    "Olympic",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "SherwinWilliams",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "Westlake",
    "WolfHomeProducts",
  ],
  Masonry_BrickModular_Rowlock: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Metal_ACM",
    "Metal_Amerimax",
    "Mortar_GeneralShale",
    "Norandex",
    "Olympic",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "SherwinWilliams",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "Westlake",
    "WolfHomeProducts",
  ],
  Masonry_BrickModular_Weave3: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Mortar_GeneralShale",
    "Norandex",
    "Olympic",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "Westlake",
    "WolfHomeProducts",
  ],
  Masonry_BrickQueen: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Metal_ACM",
    "Metal_Amerimax",
    "Mortar_GeneralShale",
    "Norandex",
    "Olympic",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "SherwinWilliams",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "Westlake",
    "WolfHomeProducts",
  ],
  Masonry_BrickQueen_HalfHeight: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Metal_ACM",
    "Metal_Amerimax",
    "Mortar_GeneralShale",
    "Norandex",
    "Olympic",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "SherwinWilliams",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "Westlake",
    "WolfHomeProducts",
  ],
  Masonry_BrickQueen_Header: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Metal_ACM",
    "Metal_Amerimax",
    "Mortar_GeneralShale",
    "Norandex",
    "Olympic",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "SherwinWilliams",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "Westlake",
    "WolfHomeProducts",
  ],
  Masonry_BrickQueen_Herringbone: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Metal_ACM",
    "Metal_Amerimax",
    "Mortar_GeneralShale",
    "Norandex",
    "Olympic",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "SherwinWilliams",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "Westlake",
    "WolfHomeProducts",
  ],
  Masonry_BrickQueen_Rowlock: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Metal_ACM",
    "Metal_Amerimax",
    "Mortar_GeneralShale",
    "Norandex",
    "Olympic",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "SherwinWilliams",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "Westlake",
    "WolfHomeProducts",
  ],
  Masonry_BrickQueen_ThinCut: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Metal_ACM",
    "Metal_Amerimax",
    "Mortar_GeneralShale",
    "Norandex",
    "Olympic",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "SherwinWilliams",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "Westlake",
    "WolfHomeProducts",
  ],
  Masonry_CinderBlock08x16: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Concrete_SherwinWilliams",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "Metal_ACM",
    "Metal_Amerimax",
    "Norandex",
    "Olympic",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "SherwinWilliams",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "Westlake",
    "WolfHomeProducts",
  ],
  Masonry_Stone_SCM_ThinkBrick: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Metal_ACM",
    "Metal_Amerimax",
    "Mortar_GeneralShale",
    "Norandex",
    "Olympic",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "SherwinWilliams",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "Westlake",
    "WolfHomeProducts",
  ],
  Metal_Powder: [
    "AlscoMetals",
    "Alside",
    "DiamondKote",
    "Dulux",
    "HaasDoor",
    "MetalPowder_Colors",
    "Metal_ABC",
    "Metal_ACM",
    "Metal_AE",
    "Metal_AFCORail",
    "Metal_ASC",
    "Metal_Amerimax",
    "Metal_BandA",
    "Metal_BerridgeColors",
    "Metal_CMG",
    "Metal_CascadiaMetals",
    "Metal_CentralStatesColors",
    "Metal_ColorKlad",
    "Metal_Colors",
    "Metal_DrexelColors",
    "Metal_Englert",
    "Metal_Everlast",
    "Metal_Fabral",
    "Metal_HomeRail",
    "Metal_JetMetals",
    "Metal_MBCI",
    "Metal_McElroy",
    "Metal_MetalRoofingSystems",
    "Metal_Mueller",
    "Metal_PAC",
    "Metal_ProSnap",
    "Metal_ProVia",
    "Metal_Scheffield",
    "Metal_SchellColors",
    "Metal_Sentriclad",
    "Metal_SpectraPro",
    "Metal_WesternStatesColors",
    "PPG",
    "RoyalBuilding",
    "SherwinWilliams",
    "TimberTech",
    "UnionCorrugating",
    "WolfHomeProducts",
  ],
  Paint_Egg: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "CHI_Colors",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "Garaga",
    "Garage_Amarr",
    "Garage_Clopay",
    "Garage_Colors",
    "Garage_DoorLink",
    "Garage_GeneralDoors",
    "Garage_Hormann",
    "Garage_Martin",
    "Garage_OverheadDoor",
    "Garage_Windsor",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Weatherables",
    "Westlake",
    "Window_Lindsay",
    "WolfHomeProducts",
  ],
  Paint_Flat: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "CHI_Colors",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "Garaga",
    "Garage_Amarr",
    "Garage_Clopay",
    "Garage_Colors",
    "Garage_DoorLink",
    "Garage_GeneralDoors",
    "Garage_Hormann",
    "Garage_Martin",
    "Garage_OverheadDoor",
    "Garage_Windsor",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Weatherables",
    "Westlake",
    "Window_Lindsay",
    "WolfHomeProducts",
  ],
  Paint_Gloss: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "CHI_Colors",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "Garaga",
    "Garage_Amarr",
    "Garage_Clopay",
    "Garage_Colors",
    "Garage_DoorLink",
    "Garage_GeneralDoors",
    "Garage_Hormann",
    "Garage_Martin",
    "Garage_OverheadDoor",
    "Garage_Windsor",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Weatherables",
    "Westlake",
    "Window_Lindsay",
    "WolfHomeProducts",
  ],
  Paint_Satin: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "CHI_Colors",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "Garaga",
    "Garage_Amarr",
    "Garage_Clopay",
    "Garage_Colors",
    "Garage_DoorLink",
    "Garage_GeneralDoors",
    "Garage_Hormann",
    "Garage_Martin",
    "Garage_OverheadDoor",
    "Garage_Windsor",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Weatherables",
    "Westlake",
    "Window_Lindsay",
    "WolfHomeProducts",
  ],
  Paint_SemiGloss: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "CHI_Colors",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "Garaga",
    "Garage_Amarr",
    "Garage_Clopay",
    "Garage_Colors",
    "Garage_DoorLink",
    "Garage_GeneralDoors",
    "Garage_Hormann",
    "Garage_Martin",
    "Garage_OverheadDoor",
    "Garage_Windsor",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Weatherables",
    "Westlake",
    "Window_Lindsay",
    "WolfHomeProducts",
  ],
  Roof_MetalShakeStraight12: [
    "AlscoMetals",
    "Alside",
    "DiamondKote",
    "Dulux",
    "HaasDoor",
    "Metal_ABC",
    "Metal_ACM",
    "Metal_AE",
    "Metal_AFCORail",
    "Metal_ASC",
    "Metal_Amerimax",
    "Metal_BandA",
    "Metal_BerridgeColors",
    "Metal_CMG",
    "Metal_CascadiaMetals",
    "Metal_CentralStatesColors",
    "Metal_ColorKlad",
    "Metal_Colors",
    "Metal_DrexelColors",
    "Metal_Englert",
    "Metal_Everlast",
    "Metal_Fabral",
    "Metal_HomeRail",
    "Metal_JetMetals",
    "Metal_MBCI",
    "Metal_McElroy",
    "Metal_MetalRoofingSystems",
    "Metal_Mueller",
    "Metal_PAC",
    "Metal_ProSnap",
    "Metal_ProVia",
    "Metal_Scheffield",
    "Metal_SchellColors",
    "Metal_Sentriclad",
    "Metal_SpectraPro",
    "Metal_WesternStatesColors",
    "PPG",
    "RoyalBuilding",
    "SherwinWilliams",
    "TimberTech",
    "UnionCorrugating",
    "WolfHomeProducts",
  ],
  Roof_StandingSeam12: [
    "AlscoMetals",
    "Alside",
    "DiamondKote",
    "Dulux",
    "HaasDoor",
    "Metal_ABC",
    "Metal_ACM",
    "Metal_AE",
    "Metal_AFCORail",
    "Metal_ASC",
    "Metal_Amerimax",
    "Metal_BandA",
    "Metal_BerridgeColors",
    "Metal_CMG",
    "Metal_CascadiaMetals",
    "Metal_CentralStatesColors",
    "Metal_ColorKlad",
    "Metal_Colors",
    "Metal_DrexelColors",
    "Metal_Englert",
    "Metal_Everlast",
    "Metal_Fabral",
    "Metal_HomeRail",
    "Metal_JetMetals",
    "Metal_MBCI",
    "Metal_McElroy",
    "Metal_MetalRoofingSystems",
    "Metal_Mueller",
    "Metal_PAC",
    "Metal_ProSnap",
    "Metal_ProVia",
    "Metal_Scheffield",
    "Metal_SchellColors",
    "Metal_Sentriclad",
    "Metal_SpectraPro",
    "Metal_WesternStatesColors",
    "PPG",
    "RoyalBuilding",
    "SherwinWilliams",
    "TimberTech",
    "UnionCorrugating",
    "WolfHomeProducts",
  ],
  Roof_StandingSeam14: [
    "AlscoMetals",
    "Alside",
    "DiamondKote",
    "Dulux",
    "HaasDoor",
    "Metal_ABC",
    "Metal_ACM",
    "Metal_AE",
    "Metal_AFCORail",
    "Metal_ASC",
    "Metal_Amerimax",
    "Metal_BandA",
    "Metal_BerridgeColors",
    "Metal_CMG",
    "Metal_CascadiaMetals",
    "Metal_CentralStatesColors",
    "Metal_ColorKlad",
    "Metal_Colors",
    "Metal_DrexelColors",
    "Metal_Englert",
    "Metal_Everlast",
    "Metal_Fabral",
    "Metal_HomeRail",
    "Metal_JetMetals",
    "Metal_MBCI",
    "Metal_McElroy",
    "Metal_MetalRoofingSystems",
    "Metal_Mueller",
    "Metal_PAC",
    "Metal_ProSnap",
    "Metal_ProVia",
    "Metal_Scheffield",
    "Metal_SchellColors",
    "Metal_Sentriclad",
    "Metal_SpectraPro",
    "Metal_WesternStatesColors",
    "PPG",
    "RoyalBuilding",
    "SherwinWilliams",
    "TimberTech",
    "UnionCorrugating",
    "WolfHomeProducts",
  ],
  Roof_StandingSeam15: [
    "AlscoMetals",
    "Alside",
    "DiamondKote",
    "Dulux",
    "HaasDoor",
    "Metal_ABC",
    "Metal_ACM",
    "Metal_AE",
    "Metal_AFCORail",
    "Metal_ASC",
    "Metal_Amerimax",
    "Metal_BandA",
    "Metal_BerridgeColors",
    "Metal_CMG",
    "Metal_CascadiaMetals",
    "Metal_CentralStatesColors",
    "Metal_ColorKlad",
    "Metal_Colors",
    "Metal_DrexelColors",
    "Metal_Englert",
    "Metal_Everlast",
    "Metal_Fabral",
    "Metal_HomeRail",
    "Metal_JetMetals",
    "Metal_MBCI",
    "Metal_McElroy",
    "Metal_MetalRoofingSystems",
    "Metal_Mueller",
    "Metal_PAC",
    "Metal_ProSnap",
    "Metal_ProVia",
    "Metal_Scheffield",
    "Metal_SchellColors",
    "Metal_Sentriclad",
    "Metal_SpectraPro",
    "Metal_WesternStatesColors",
    "PPG",
    "RoyalBuilding",
    "SherwinWilliams",
    "TimberTech",
    "UnionCorrugating",
    "WolfHomeProducts",
  ],
  Roof_StandingSeam16: [
    "AlscoMetals",
    "Alside",
    "DiamondKote",
    "Dulux",
    "HaasDoor",
    "Metal_ABC",
    "Metal_ACM",
    "Metal_AE",
    "Metal_AFCORail",
    "Metal_ASC",
    "Metal_Amerimax",
    "Metal_BandA",
    "Metal_BerridgeColors",
    "Metal_CMG",
    "Metal_CascadiaMetals",
    "Metal_CentralStatesColors",
    "Metal_ColorKlad",
    "Metal_Colors",
    "Metal_DrexelColors",
    "Metal_Englert",
    "Metal_Everlast",
    "Metal_Fabral",
    "Metal_HomeRail",
    "Metal_JetMetals",
    "Metal_MBCI",
    "Metal_McElroy",
    "Metal_MetalRoofingSystems",
    "Metal_Mueller",
    "Metal_PAC",
    "Metal_ProSnap",
    "Metal_ProVia",
    "Metal_Scheffield",
    "Metal_SchellColors",
    "Metal_Sentriclad",
    "Metal_SpectraPro",
    "Metal_WesternStatesColors",
    "PPG",
    "RoyalBuilding",
    "SherwinWilliams",
    "TimberTech",
    "UnionCorrugating",
    "WolfHomeProducts",
  ],
  Roof_StandingSeam18: [
    "AlscoMetals",
    "Alside",
    "DiamondKote",
    "Dulux",
    "HaasDoor",
    "Metal_ABC",
    "Metal_ACM",
    "Metal_AE",
    "Metal_AFCORail",
    "Metal_ASC",
    "Metal_Amerimax",
    "Metal_BandA",
    "Metal_BerridgeColors",
    "Metal_CMG",
    "Metal_CascadiaMetals",
    "Metal_CentralStatesColors",
    "Metal_ColorKlad",
    "Metal_Colors",
    "Metal_DrexelColors",
    "Metal_Englert",
    "Metal_Everlast",
    "Metal_Fabral",
    "Metal_HomeRail",
    "Metal_JetMetals",
    "Metal_MBCI",
    "Metal_McElroy",
    "Metal_MetalRoofingSystems",
    "Metal_Mueller",
    "Metal_PAC",
    "Metal_ProSnap",
    "Metal_ProVia",
    "Metal_Scheffield",
    "Metal_SchellColors",
    "Metal_Sentriclad",
    "Metal_SpectraPro",
    "Metal_WesternStatesColors",
    "PPG",
    "RoyalBuilding",
    "SherwinWilliams",
    "TimberTech",
    "UnionCorrugating",
    "WolfHomeProducts",
  ],
  Roof_StandingSeam24: [
    "AlscoMetals",
    "Alside",
    "DiamondKote",
    "Dulux",
    "HaasDoor",
    "Metal_ABC",
    "Metal_ACM",
    "Metal_AE",
    "Metal_AFCORail",
    "Metal_ASC",
    "Metal_Amerimax",
    "Metal_BandA",
    "Metal_BerridgeColors",
    "Metal_CMG",
    "Metal_CascadiaMetals",
    "Metal_CentralStatesColors",
    "Metal_ColorKlad",
    "Metal_Colors",
    "Metal_DrexelColors",
    "Metal_Englert",
    "Metal_Everlast",
    "Metal_Fabral",
    "Metal_HomeRail",
    "Metal_JetMetals",
    "Metal_MBCI",
    "Metal_McElroy",
    "Metal_MetalRoofingSystems",
    "Metal_Mueller",
    "Metal_PAC",
    "Metal_ProSnap",
    "Metal_ProVia",
    "Metal_Scheffield",
    "Metal_SchellColors",
    "Metal_Sentriclad",
    "Metal_SpectraPro",
    "Metal_WesternStatesColors",
    "PPG",
    "RoyalBuilding",
    "SherwinWilliams",
    "TimberTech",
    "UnionCorrugating",
    "WolfHomeProducts",
  ],
  Roof_StandingSeamIR: [
    "AlscoMetals",
    "Alside",
    "DiamondKote",
    "Dulux",
    "HaasDoor",
    "Metal_ABC",
    "Metal_ACM",
    "Metal_AE",
    "Metal_AFCORail",
    "Metal_ASC",
    "Metal_Amerimax",
    "Metal_BandA",
    "Metal_BerridgeColors",
    "Metal_CMG",
    "Metal_CascadiaMetals",
    "Metal_CentralStatesColors",
    "Metal_ColorKlad",
    "Metal_Colors",
    "Metal_DrexelColors",
    "Metal_Englert",
    "Metal_Everlast",
    "Metal_Fabral",
    "Metal_HomeRail",
    "Metal_JetMetals",
    "Metal_MBCI",
    "Metal_McElroy",
    "Metal_MetalRoofingSystems",
    "Metal_Mueller",
    "Metal_PAC",
    "Metal_ProSnap",
    "Metal_ProVia",
    "Metal_Scheffield",
    "Metal_SchellColors",
    "Metal_Sentriclad",
    "Metal_SpectraPro",
    "Metal_WesternStatesColors",
    "PPG",
    "RoyalBuilding",
    "SherwinWilliams",
    "TimberTech",
    "UnionCorrugating",
    "WolfHomeProducts",
  ],
  Roof_StandingSeamPBU_Galvanized: [
    "AlscoMetals",
    "Alside",
    "DiamondKote",
    "Dulux",
    "HaasDoor",
    "Metal_ABC",
    "Metal_ACM",
    "Metal_AE",
    "Metal_AFCORail",
    "Metal_ASC",
    "Metal_Amerimax",
    "Metal_BandA",
    "Metal_BerridgeColors",
    "Metal_CMG",
    "Metal_CascadiaMetals",
    "Metal_CentralStatesColors",
    "Metal_ColorKlad",
    "Metal_Colors",
    "Metal_DrexelColors",
    "Metal_Englert",
    "Metal_Everlast",
    "Metal_Fabral",
    "Metal_HomeRail",
    "Metal_JetMetals",
    "Metal_MBCI",
    "Metal_McElroy",
    "Metal_MetalRoofingSystems",
    "Metal_Mueller",
    "Metal_PAC",
    "Metal_ProSnap",
    "Metal_ProVia",
    "Metal_Scheffield",
    "Metal_SchellColors",
    "Metal_Sentriclad",
    "Metal_SpectraPro",
    "Metal_WesternStatesColors",
    "PPG",
    "RoyalBuilding",
    "SherwinWilliams",
    "TimberTech",
    "UnionCorrugating",
    "WolfHomeProducts",
  ],
  RoofTile_Elabana: ["Monier"],
  RoofTrim_StandingSeam: [
    "AlscoMetals",
    "Alside",
    "DiamondKote",
    "Dulux",
    "HaasDoor",
    "Metal_ABC",
    "Metal_ACM",
    "Metal_AE",
    "Metal_AFCORail",
    "Metal_ASC",
    "Metal_Amerimax",
    "Metal_BandA",
    "Metal_BerridgeColors",
    "Metal_CMG",
    "Metal_CascadiaMetals",
    "Metal_CentralStatesColors",
    "Metal_ColorKlad",
    "Metal_Colors",
    "Metal_DrexelColors",
    "Metal_Englert",
    "Metal_Everlast",
    "Metal_Fabral",
    "Metal_HomeRail",
    "Metal_JetMetals",
    "Metal_MBCI",
    "Metal_McElroy",
    "Metal_MetalRoofingSystems",
    "Metal_Mueller",
    "Metal_PAC",
    "Metal_ProSnap",
    "Metal_ProVia",
    "Metal_Scheffield",
    "Metal_SchellColors",
    "Metal_Sentriclad",
    "Metal_SpectraPro",
    "Metal_WesternStatesColors",
    "PPG",
    "RoyalBuilding",
    "SherwinWilliams",
    "TimberTech",
    "UnionCorrugating",
    "WolfHomeProducts",
  ],
  Shutter: [
    "FoundrySiding",
    "GeorgiaPacific",
    "Masonite",
    "Norandex",
    "Olympic",
    "PlyGem",
    "Richwood",
    "Schell_Colors",
  ],
  Soffit_Slat: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "BenjaminMoore",
    "BuildersEdge",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "Metal_ACM",
    "Metal_Amerimax",
    "Norandex",
    "Olympic",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_Board48x120_Battens02h: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten01hx06q: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten01hx07: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten01hx08: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten01hx12: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten01hx16: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten01hx20: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten01hx24: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten01hx36: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten01hx48: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten01x07: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten01x08: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten01x12: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten01x16: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten01x20: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten01x24: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten01x36: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten01x48: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten02hx07: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten02hx08: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten02hx09: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten02hx12: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten02hx16: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten02hx16_Grain: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
    "Wood_Messmers",
  ],
  Wall_BoardBatten02hx20: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten02hx24: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten02hx36: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten02hx48: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten02x07: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten02x08: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten02x12: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten02x16: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten02x16_Grain: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
    "Wood_Messmers",
  ],
  Wall_BoardBatten02x20: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten02x24: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten02x36: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten02x48: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten03hx07: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten03hx08: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten03hx12: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten03hx16: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten03hx20: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten03hx24: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten03hx36: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten03hx48: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten03x07: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten03x08: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten03x12: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten03x16: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten03x20: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten03x24: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten03x36: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten03x48: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten04hx07: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten04hx08: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten04hx12: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten04hx16: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten04hx20: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten04hx24: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten04hx36: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten04hx48: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten04x07: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten04x08: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten04x12: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten04x16: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten04x20: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten04x24: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten04x36: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten04x48: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten05hx07: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten05hx08: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten05hx12: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten05hx16: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten05hx20: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten05hx24: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten05hx36: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten05hx48: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten05x07: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten05x08: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten05x12: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten05x16: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten05x20: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten05x24: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten05x36: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten05x48: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten06hx07: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten06hx08: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten06hx12: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten06hx16: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten06hx20: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten06hx24: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten06hx36: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten06hx48: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten06x07: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten06x08: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten06x12: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten06x16: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten06x20: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten06x24: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten06x36: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardBatten06x48: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardLap02: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardLap02_Grain: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
    "Wood_Messmers",
  ],
  Wall_BoardLap03: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardLap03_Grain: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
    "Wood_Messmers",
  ],
  Wall_BoardLap04: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardLap04_Grain: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
    "Wood_Messmers",
  ],
  Wall_BoardLap04h: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardLap04h_Dutch: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardLap05: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardLap05_Grain: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
    "Wood_Messmers",
  ],
  Wall_BoardLap06: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardLap06_Gap01h: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardLap06_Grain: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
    "Wood_Messmers",
  ],
  Wall_BoardLap07: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardLap07_Grain: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
    "Wood_Messmers",
  ],
  Wall_BoardLap08: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardLap08_Grain: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
    "Wood_Messmers",
  ],
  Wall_BoardLap10: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardLap10_Grain: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
    "Wood_Messmers",
  ],
  Wall_BoardLap12: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardLap12_Grain: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
    "Wood_Messmers",
  ],
  Wall_BoardLapAlternating04x07: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_BoardLapAlternating05x08: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_HorizontalBoard02_01hx48vertical: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
    "Wood_MicroProSienna",
  ],
  Wall_HorizontalBoard04: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
    "Wood_MicroProSienna",
  ],
  Wall_HorizontalBoard04_Grain: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
    "Wood_Messmers",
    "Wood_MicroProSienna",
  ],
  Wall_HorizontalBoard05: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
    "Wood_MicroProSienna",
  ],
  Wall_HorizontalBoard05_Grain: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
    "Wood_Messmers",
    "Wood_MicroProSienna",
  ],
  Wall_HorizontalBoard05h_Grain: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
    "Wood_Messmers",
    "Wood_MicroProSienna",
  ],
  Wall_HorizontalBoard06: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
    "Wood_MicroProSienna",
  ],
  Wall_HorizontalBoard06_Grain: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
    "Wood_Messmers",
    "Wood_MicroProSienna",
  ],
  Wall_HorizontalBoard07: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
    "Wood_MicroProSienna",
  ],
  Wall_HorizontalBoard07_Grain: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
    "Wood_Messmers",
    "Wood_MicroProSienna",
  ],
  Wall_HorizontalBoard08: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
    "Wood_MicroProSienna",
  ],
  Wall_HorizontalBoard08_Angle45L: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
    "Wood_MicroProSienna",
  ],
  Wall_HorizontalBoard08_Angle45R: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
    "Wood_MicroProSienna",
  ],
  Wall_HorizontalBoard08_Grain: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
    "Wood_Messmers",
    "Wood_MicroProSienna",
  ],
  Wall_PanelBoard_48x24: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "CHI_Colors",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "Garaga",
    "Garage_Amarr",
    "Garage_Clopay",
    "Garage_Colors",
    "Garage_DoorLink",
    "Garage_GeneralDoors",
    "Garage_Hormann",
    "Garage_Martin",
    "Garage_OverheadDoor",
    "Garage_Windsor",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Weatherables",
    "Westlake",
    "Window_Lindsay",
    "WolfHomeProducts",
  ],
  Wall_PanelBoard_V_48: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "CHI_Colors",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "Garaga",
    "Garage_Amarr",
    "Garage_Clopay",
    "Garage_Colors",
    "Garage_DoorLink",
    "Garage_GeneralDoors",
    "Garage_Hormann",
    "Garage_Martin",
    "Garage_OverheadDoor",
    "Garage_Windsor",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Weatherables",
    "Westlake",
    "Window_Lindsay",
    "WolfHomeProducts",
  ],
  Wall_ReverseBatten05hx01: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_ScaleShingle07: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_ShakeShingle06: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_ShakeShingle07: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_ShakeShingle09: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_ShakeShingleStraight05: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_ShakeShingleStraight06: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_ShakeShingleStraight07: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_StaggerBoard05: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_Stucco: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_StuccoFine: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_StuccoScored04: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_StuccoScored06: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_StuccoScored07: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_StuccoScored08: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_StuccoScored10: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_StuccoScored12: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_StuccoScored14: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_StuccoScored16: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_StuccoScored18: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_StuccoScored20: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_StuccoScored22: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_StuccoScored24: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
  ],
  Wall_VerticalBoard02: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "CHI_Colors",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "Garaga",
    "Garage_Amarr",
    "Garage_Clopay",
    "Garage_Colors",
    "Garage_DoorLink",
    "Garage_GeneralDoors",
    "Garage_Hormann",
    "Garage_Martin",
    "Garage_OverheadDoor",
    "Garage_Windsor",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "Window_AMSCO",
    "Window_Andersen",
    "Window_Cascade",
    "Window_Colors",
    "Window_Gerkin",
    "Window_Harvey",
    "Window_HoffmanWeber",
    "Window_JeldWen",
    "WolfHomeProducts",
    "Wood_ChamClad",
    "Wood_Fiberon",
    "Wood_LUX",
    "Wood_Messmers",
    "Wood_MicroProSienna",
    "Wood_OldMasters",
    "Wood_Olympic",
    "Wood_PittsburghStains",
    "Wood_ProWood",
    "Wood_Varathane",
    "Wood_WayneDalton",
  ],
  Wall_VerticalBoard02_Grain: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "CHI_Colors",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "Garaga",
    "Garage_Amarr",
    "Garage_Clopay",
    "Garage_Colors",
    "Garage_DoorLink",
    "Garage_GeneralDoors",
    "Garage_Hormann",
    "Garage_Martin",
    "Garage_OverheadDoor",
    "Garage_Windsor",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "Window_AMSCO",
    "Window_Andersen",
    "Window_Cascade",
    "Window_Colors",
    "Window_Gerkin",
    "Window_Harvey",
    "Window_HoffmanWeber",
    "Window_JeldWen",
    "WolfHomeProducts",
    "Wood_ChamClad",
    "Wood_Fiberon",
    "Wood_LUX",
    "Wood_Messmers",
    "Wood_MicroProSienna",
    "Wood_OldMasters",
    "Wood_Olympic",
    "Wood_PittsburghStains",
    "Wood_ProWood",
    "Wood_Varathane",
    "Wood_WayneDalton",
  ],
  Wall_VerticalBoard03: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "CHI_Colors",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "Garaga",
    "Garage_Amarr",
    "Garage_Clopay",
    "Garage_Colors",
    "Garage_DoorLink",
    "Garage_GeneralDoors",
    "Garage_Hormann",
    "Garage_Martin",
    "Garage_OverheadDoor",
    "Garage_Windsor",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "Window_AMSCO",
    "Window_Andersen",
    "Window_Cascade",
    "Window_Colors",
    "Window_Gerkin",
    "Window_Harvey",
    "Window_HoffmanWeber",
    "Window_JeldWen",
    "WolfHomeProducts",
    "Wood_ChamClad",
    "Wood_Fiberon",
    "Wood_LUX",
    "Wood_Messmers",
    "Wood_MicroProSienna",
    "Wood_OldMasters",
    "Wood_Olympic",
    "Wood_PittsburghStains",
    "Wood_ProWood",
    "Wood_Varathane",
    "Wood_WayneDalton",
  ],
  Wall_VerticalBoard03_Grain: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "CHI_Colors",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "Garaga",
    "Garage_Amarr",
    "Garage_Clopay",
    "Garage_Colors",
    "Garage_DoorLink",
    "Garage_GeneralDoors",
    "Garage_Hormann",
    "Garage_Martin",
    "Garage_OverheadDoor",
    "Garage_Windsor",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "Window_AMSCO",
    "Window_Andersen",
    "Window_Cascade",
    "Window_Colors",
    "Window_Gerkin",
    "Window_Harvey",
    "Window_HoffmanWeber",
    "Window_JeldWen",
    "WolfHomeProducts",
    "Wood_ChamClad",
    "Wood_Fiberon",
    "Wood_LUX",
    "Wood_Messmers",
    "Wood_MicroProSienna",
    "Wood_OldMasters",
    "Wood_Olympic",
    "Wood_PittsburghStains",
    "Wood_ProWood",
    "Wood_Varathane",
    "Wood_WayneDalton",
  ],
  Wall_VerticalBoard04: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "CHI_Colors",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "Garaga",
    "Garage_Amarr",
    "Garage_Clopay",
    "Garage_Colors",
    "Garage_DoorLink",
    "Garage_GeneralDoors",
    "Garage_Hormann",
    "Garage_Martin",
    "Garage_OverheadDoor",
    "Garage_Windsor",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "Window_AMSCO",
    "Window_Andersen",
    "Window_Cascade",
    "Window_Colors",
    "Window_Gerkin",
    "Window_Harvey",
    "Window_HoffmanWeber",
    "Window_JeldWen",
    "WolfHomeProducts",
    "Wood_ChamClad",
    "Wood_Fiberon",
    "Wood_LUX",
    "Wood_Messmers",
    "Wood_MicroProSienna",
    "Wood_OldMasters",
    "Wood_Olympic",
    "Wood_PittsburghStains",
    "Wood_ProWood",
    "Wood_Varathane",
    "Wood_WayneDalton",
  ],
  Wall_VerticalBoard04_Grain: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "CHI_Colors",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "Garaga",
    "Garage_Amarr",
    "Garage_Clopay",
    "Garage_Colors",
    "Garage_DoorLink",
    "Garage_GeneralDoors",
    "Garage_Hormann",
    "Garage_Martin",
    "Garage_OverheadDoor",
    "Garage_Windsor",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "Window_AMSCO",
    "Window_Andersen",
    "Window_Cascade",
    "Window_Colors",
    "Window_Gerkin",
    "Window_Harvey",
    "Window_HoffmanWeber",
    "Window_JeldWen",
    "WolfHomeProducts",
    "Wood_ChamClad",
    "Wood_Fiberon",
    "Wood_LUX",
    "Wood_Messmers",
    "Wood_MicroProSienna",
    "Wood_OldMasters",
    "Wood_Olympic",
    "Wood_PittsburghStains",
    "Wood_ProWood",
    "Wood_Varathane",
    "Wood_WayneDalton",
  ],
  Wall_VerticalBoard05: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "CHI_Colors",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "Garaga",
    "Garage_Amarr",
    "Garage_Clopay",
    "Garage_Colors",
    "Garage_DoorLink",
    "Garage_GeneralDoors",
    "Garage_Hormann",
    "Garage_Martin",
    "Garage_OverheadDoor",
    "Garage_Windsor",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "Window_AMSCO",
    "Window_Andersen",
    "Window_Cascade",
    "Window_Colors",
    "Window_Gerkin",
    "Window_Harvey",
    "Window_HoffmanWeber",
    "Window_JeldWen",
    "WolfHomeProducts",
    "Wood_ChamClad",
    "Wood_Fiberon",
    "Wood_LUX",
    "Wood_Messmers",
    "Wood_MicroProSienna",
    "Wood_OldMasters",
    "Wood_Olympic",
    "Wood_PittsburghStains",
    "Wood_ProWood",
    "Wood_Varathane",
    "Wood_WayneDalton",
  ],
  Wall_VerticalBoard05_Grain: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "CHI_Colors",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "Garaga",
    "Garage_Amarr",
    "Garage_Clopay",
    "Garage_Colors",
    "Garage_DoorLink",
    "Garage_GeneralDoors",
    "Garage_Hormann",
    "Garage_Martin",
    "Garage_OverheadDoor",
    "Garage_Windsor",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "Window_AMSCO",
    "Window_Andersen",
    "Window_Cascade",
    "Window_Colors",
    "Window_Gerkin",
    "Window_Harvey",
    "Window_HoffmanWeber",
    "Window_JeldWen",
    "WolfHomeProducts",
    "Wood_ChamClad",
    "Wood_Fiberon",
    "Wood_LUX",
    "Wood_Messmers",
    "Wood_MicroProSienna",
    "Wood_OldMasters",
    "Wood_Olympic",
    "Wood_PittsburghStains",
    "Wood_ProWood",
    "Wood_Varathane",
    "Wood_WayneDalton",
  ],
  Wall_VerticalBoard05H: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "CHI_Colors",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "Garaga",
    "Garage_Amarr",
    "Garage_Clopay",
    "Garage_Colors",
    "Garage_DoorLink",
    "Garage_GeneralDoors",
    "Garage_Hormann",
    "Garage_Martin",
    "Garage_OverheadDoor",
    "Garage_Windsor",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "Window_AMSCO",
    "Window_Andersen",
    "Window_Cascade",
    "Window_Colors",
    "Window_Gerkin",
    "Window_Harvey",
    "Window_HoffmanWeber",
    "Window_JeldWen",
    "WolfHomeProducts",
    "Wood_ChamClad",
    "Wood_Fiberon",
    "Wood_LUX",
    "Wood_Messmers",
    "Wood_MicroProSienna",
    "Wood_OldMasters",
    "Wood_Olympic",
    "Wood_PittsburghStains",
    "Wood_ProWood",
    "Wood_Varathane",
    "Wood_WayneDalton",
  ],
  Wall_VerticalBoard05H_Grain: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "CHI_Colors",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "Garaga",
    "Garage_Amarr",
    "Garage_Clopay",
    "Garage_Colors",
    "Garage_DoorLink",
    "Garage_GeneralDoors",
    "Garage_Hormann",
    "Garage_Martin",
    "Garage_OverheadDoor",
    "Garage_Windsor",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "Window_AMSCO",
    "Window_Andersen",
    "Window_Cascade",
    "Window_Colors",
    "Window_Gerkin",
    "Window_Harvey",
    "Window_HoffmanWeber",
    "Window_JeldWen",
    "WolfHomeProducts",
    "Wood_ChamClad",
    "Wood_Fiberon",
    "Wood_LUX",
    "Wood_Messmers",
    "Wood_MicroProSienna",
    "Wood_OldMasters",
    "Wood_Olympic",
    "Wood_PittsburghStains",
    "Wood_ProWood",
    "Wood_Varathane",
    "Wood_WayneDalton",
  ],
  Wall_VerticalBoard06: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "CHI_Colors",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "Garaga",
    "Garage_Amarr",
    "Garage_Clopay",
    "Garage_Colors",
    "Garage_DoorLink",
    "Garage_GeneralDoors",
    "Garage_Hormann",
    "Garage_Martin",
    "Garage_OverheadDoor",
    "Garage_Windsor",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "Window_AMSCO",
    "Window_Andersen",
    "Window_Cascade",
    "Window_Colors",
    "Window_Gerkin",
    "Window_Harvey",
    "Window_HoffmanWeber",
    "Window_JeldWen",
    "WolfHomeProducts",
    "Wood_ChamClad",
    "Wood_Fiberon",
    "Wood_LUX",
    "Wood_Messmers",
    "Wood_MicroProSienna",
    "Wood_OldMasters",
    "Wood_Olympic",
    "Wood_PittsburghStains",
    "Wood_ProWood",
    "Wood_Varathane",
    "Wood_WayneDalton",
  ],
  Wall_VerticalBoard06_Beaded01h: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "CHI_Colors",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "Garaga",
    "Garage_Amarr",
    "Garage_Clopay",
    "Garage_Colors",
    "Garage_DoorLink",
    "Garage_GeneralDoors",
    "Garage_Hormann",
    "Garage_Martin",
    "Garage_OverheadDoor",
    "Garage_Windsor",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "Window_AMSCO",
    "Window_Andersen",
    "Window_Cascade",
    "Window_Colors",
    "Window_Gerkin",
    "Window_Harvey",
    "Window_HoffmanWeber",
    "Window_JeldWen",
    "WolfHomeProducts",
    "Wood_ChamClad",
    "Wood_Fiberon",
    "Wood_LUX",
    "Wood_Messmers",
    "Wood_MicroProSienna",
    "Wood_OldMasters",
    "Wood_Olympic",
    "Wood_PittsburghStains",
    "Wood_ProWood",
    "Wood_Varathane",
    "Wood_WayneDalton",
  ],
  Wall_VerticalBoard06_Grain: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "CHI_Colors",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "Garaga",
    "Garage_Amarr",
    "Garage_Clopay",
    "Garage_Colors",
    "Garage_DoorLink",
    "Garage_GeneralDoors",
    "Garage_Hormann",
    "Garage_Martin",
    "Garage_OverheadDoor",
    "Garage_Windsor",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "Window_AMSCO",
    "Window_Andersen",
    "Window_Cascade",
    "Window_Colors",
    "Window_Gerkin",
    "Window_Harvey",
    "Window_HoffmanWeber",
    "Window_JeldWen",
    "WolfHomeProducts",
    "Wood_ChamClad",
    "Wood_Fiberon",
    "Wood_LUX",
    "Wood_Messmers",
    "Wood_MicroProSienna",
    "Wood_OldMasters",
    "Wood_Olympic",
    "Wood_PittsburghStains",
    "Wood_ProWood",
    "Wood_Varathane",
    "Wood_WayneDalton",
  ],
  Wall_VerticalBoard08: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "CHI_Colors",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "Garaga",
    "Garage_Amarr",
    "Garage_Clopay",
    "Garage_Colors",
    "Garage_DoorLink",
    "Garage_GeneralDoors",
    "Garage_Hormann",
    "Garage_Martin",
    "Garage_OverheadDoor",
    "Garage_Windsor",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "Window_AMSCO",
    "Window_Andersen",
    "Window_Cascade",
    "Window_Colors",
    "Window_Gerkin",
    "Window_Harvey",
    "Window_HoffmanWeber",
    "Window_JeldWen",
    "WolfHomeProducts",
    "Wood_ChamClad",
    "Wood_Fiberon",
    "Wood_LUX",
    "Wood_Messmers",
    "Wood_MicroProSienna",
    "Wood_OldMasters",
    "Wood_Olympic",
    "Wood_PittsburghStains",
    "Wood_ProWood",
    "Wood_Varathane",
    "Wood_WayneDalton",
  ],
  Wall_VerticalBoard08_Grain: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "CHI_Colors",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "Garaga",
    "Garage_Amarr",
    "Garage_Clopay",
    "Garage_Colors",
    "Garage_DoorLink",
    "Garage_GeneralDoors",
    "Garage_Hormann",
    "Garage_Martin",
    "Garage_OverheadDoor",
    "Garage_Windsor",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "Window_AMSCO",
    "Window_Andersen",
    "Window_Cascade",
    "Window_Colors",
    "Window_Gerkin",
    "Window_Harvey",
    "Window_HoffmanWeber",
    "Window_JeldWen",
    "WolfHomeProducts",
    "Wood_ChamClad",
    "Wood_Fiberon",
    "Wood_LUX",
    "Wood_Messmers",
    "Wood_MicroProSienna",
    "Wood_OldMasters",
    "Wood_Olympic",
    "Wood_PittsburghStains",
    "Wood_ProWood",
    "Wood_Varathane",
    "Wood_WayneDalton",
  ],
  Window: [
    "Alside",
    "Window_AAF",
    "Window_AMSCO",
    "Window_AllTemp",
    "Window_Alliance",
    "Window_Andersen",
    "Window_Anderson",
    "Window_Atrium",
    "Window_Cascade",
    "Window_Colors",
    "Window_Elevate",
    "Window_Gerkin",
    "Window_Harvey",
    "Window_HoffmanWeber",
    "Window_JeldWen",
    "Window_Lindsay",
    "Window_MGM",
    "Window_MI",
    "Window_Marvin",
    "Window_MidwayWindows",
    "Window_Milgard",
    "Window_PGT",
    "Window_Pella",
    "Window_PlyGem",
    "Window_Prime",
    "Window_Reliabilt",
    "Window_Silverline",
    "Window_United",
    "Window_Westlake",
    "Window_WinDor",
    "Window_Windsor",
    "Window_YKK",
  ],
  Wood_Generic: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "CHI_Colors",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "DuraSeal_Stains",
    "FloridaPaints",
    "FoundrySiding",
    "Garaga",
    "Garage_Amarr",
    "Garage_Clopay",
    "Garage_Colors",
    "Garage_DoorLink",
    "Garage_GeneralDoors",
    "Garage_Hormann",
    "Garage_Martin",
    "Garage_OverheadDoor",
    "Garage_Windsor",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "MW_SherwinWilliamsStains",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Weatherables",
    "Westlake",
    "Window_Lindsay",
    "WolfHomeProducts",
    "Wood_ChamClad",
    "Wood_Fiberon",
    "Wood_LUX",
    "Wood_Messmers",
    "Wood_MicroProSienna",
    "Wood_OldMasters",
    "Wood_Olympic",
    "Wood_PittsburghStains",
    "Wood_ProWood",
    "Wood_Varathane",
    "Wood_WayneDalton",
  ],
  Wood_Generic_V: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "CHI_Colors",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "DuraSeal_Stains",
    "FloridaPaints",
    "FoundrySiding",
    "Garaga",
    "Garage_Amarr",
    "Garage_Clopay",
    "Garage_Colors",
    "Garage_DoorLink",
    "Garage_GeneralDoors",
    "Garage_Hormann",
    "Garage_Martin",
    "Garage_OverheadDoor",
    "Garage_Windsor",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "MW_SherwinWilliamsStains",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Weatherables",
    "Westlake",
    "Window_Lindsay",
    "WolfHomeProducts",
    "Wood_ChamClad",
    "Wood_Fiberon",
    "Wood_LUX",
    "Wood_Messmers",
    "Wood_MicroProSienna",
    "Wood_OldMasters",
    "Wood_Olympic",
    "Wood_PittsburghStains",
    "Wood_ProWood",
    "Wood_Varathane",
    "Wood_WayneDalton",
  ],
  Wood_HorizontalPlank: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "Waudena",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
    "Wood_Fiberon",
    "Wood_OldMasters",
    "Wood_ProWood",
  ],
  Wood_StaggeredPlank: [
    "AlscoMetals",
    "Alside",
    "Ascend",
    "Behr",
    "BenjaminMoore",
    "BuildersEdge",
    "Certainteed",
    "DiamondKote",
    "Dulux",
    "DunnEdwards",
    "FloridaPaints",
    "FoundrySiding",
    "GeorgiaPacific",
    "Glidden",
    "HaasDoor",
    "Harris",
    "JamesHardie",
    "KellyMoore",
    "LP_SmartSide",
    "Masonite",
    "McCormick",
    "Metal_ACM",
    "Metal_Amerimax",
    "MidAmerica",
    "Norandex",
    "Olympic",
    "Omega_Stucco",
    "PPG",
    "PaintSpare_Colors",
    "PlyGem",
    "RoyalBuilding",
    "Schell_Colors",
    "SherwinWilliams",
    "Superior",
    "ThermaTru",
    "TimberTech",
    "Variform",
    "WausauSupply",
    "WayneDalton",
    "Westlake",
    "WolfHomeProducts",
    "Wood_Fiberon",
    "Wood_OldMasters",
    "Wood_ProWood",
  ],
};
